import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PropertyInformationPopoverSubHeader({
  children
}) {
  return /*#__PURE__*/_jsx(Text, {
    typography: "heading-25",
    color: "text-primary-subtle",
    marginBlockEnd: "100",
    children: children
  });
}